// copy this file into config.js and set the right settings

// url of the server
const serverUrl = "https://api.account.freedrum.rocks";

export default serverUrl;
